import { render, staticRenderFns } from "./ItemRenderer.vue?vue&type=template&id=31935052&"
import script from "./ItemRenderer.vue?vue&type=script&lang=js&"
export * from "./ItemRenderer.vue?vue&type=script&lang=js&"
import style0 from "./ItemRenderer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31935052')) {
      api.createRecord('31935052', component.options)
    } else {
      api.reload('31935052', component.options)
    }
    module.hot.accept("./ItemRenderer.vue?vue&type=template&id=31935052&", function () {
      api.rerender('31935052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/templates/invoices/schema/ItemRenderer.vue"
export default component.exports